import axios from "axios";

// Prefer REACT_APP_API_URL (REST-specific override). Fall back to
// REACT_APP_BASE_URL which Apollo already reads — most envs only set the
// latter, and having two unrelated names for the same thing has bitten us
// once already (form-schemas REST calls hitting localhost:3000 instead of
// the real backend).
const axiosServices = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:3000/",
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response.status === 401 &&
      !window.location.href.includes("/login")
    ) {
      window.location.pathname = "/login";
    }
    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);

export default axiosServices;
